import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkAppVersion, clearCacheAndReload } from '@/utils/errorHandler';

interface AppUpdateNotificationProps {
  checkInterval?: number; // in milliseconds, default 1 hour
}

const AppUpdateNotification: React.FC<AppUpdateNotificationProps> = ({
  checkInterval = 60 * 60 * 1000, //  1 hour
}) => {
  const { t } = useTranslation();
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        const hasUpdate = await checkAppVersion();
        if (hasUpdate) {
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.error('Failed to check for app updates:', error);
      }
    };

    // Check for updates on mount
    checkForUpdates();

    // Set up interval to check for updates
    const interval = setInterval(checkForUpdates, checkInterval);

    return () => clearInterval(interval);
  }, [checkInterval]);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await clearCacheAndReload();
    } catch (error) {
      console.error('Failed to refresh app:', error);
      // Fallback to simple reload
      window.location.reload();
    }
  };

  // const handleDismiss = () => {
  //   setUpdateAvailable(false);
  // };

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-4 right-4 bg-blue-600 text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <h3 className="font-semibold text-sm mb-1">
            {t('AppUpdateNotification.title')}
          </h3>
          <p className="text-xs text-blue-100 mb-3">
            {t('AppUpdateNotification.description')}
          </p>
          <div className="flex gap-2">
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className="px-3 py-1 bg-white text-blue-600 rounded text-xs font-medium hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isRefreshing
                ? t('AppUpdateNotification.refreshing')
                : t('AppUpdateNotification.refresh')}
            </button>
            {/* <button
              onClick={handleDismiss}
              className="px-3 py-1 bg-blue-700 text-white rounded text-xs font-medium hover:bg-blue-800"
            >
              {t('AppUpdateNotification.later', 'Later')}
            </button> */}
          </div>
        </div>
        {/* <button
          onClick={handleDismiss}
          className="text-blue-200 hover:text-white text-lg leading-none"
        >
          ×
        </button> */}
      </div>
    </div>
  );
};

export default AppUpdateNotification;
